import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import { NBSP } from '../../../../constants/symbols';
import { IValuationFiltersProps } from '../../types/public';

import * as styles from './styles.css';

export const ValuationFiltersDesktop: React.FC<IValuationFiltersProps> = ({
  subdomain,
  mainFiltersWidget,
  valuationFiltersSubmit,
}) => {
  return (
    <div {...mergeStyles(styles['valuation_header'], styles[`background-for--${subdomain}`])}>
      <div className={styles['header_darkness']}>
        <div className={styles['title-container']}>
          <p className={styles['title']}>Узнайте рыночную стоимость{NBSP}недвижимости</p>
        </div>
        <div className={styles['wrapper']}>
          <div className={styles['header_container']}>
            <div className={styles['wrapper_label']}>{mainFiltersWidget}</div>
            <div className={styles['wrapper_button']}>{valuationFiltersSubmit}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

ValuationFiltersDesktop.displayName = 'ValuationFiltersDesktop';
